import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useSelector, useDispatch } from 'react-redux';
import styles from './navbar.module.css';

import {
  openNavBar,
  closeNavBar,
} from '../../lib/redux/navBarCollapse/navBarCollapseSlice';
import Text from '../../shared/Text';

const Tab = ({ children, active, info, linkOptions, link, itemId }) => {
  return (
    <Li active={active}>
      <Link
        as="a"
        variant="subtitle2"
        active={active}
        href={link}
        title={info}
        {...linkOptions}
        data-active-tab={itemId}
      >
        {children}
      </Link>
    </Li>
  );
};

const NavigationBar = ({ content }) => {
  const { collapsed, locked } = useSelector(state => state.navBarCollapse);
  const dispatch = useDispatch();
  const fullUrl = window.location.pathname + window.location.hash;
  const isActive = link => link === fullUrl;

  return (
    <>
      <div className={styles.placeholder} />
      <Nav
        locked={locked}
        onMouseEnter={() => dispatch(openNavBar())}
        onMouseLeave={() => dispatch(closeNavBar())}
        data-cy="navigationBar"
      >
        <Ul collapsed={collapsed}>
          {content.slice(0, -2).map(item => (
            <Tab
              key={item.itemId}
              active={isActive(item.link)}
              info={item.info}
              linkOptions={item.linkOptions}
              link={item.link}
              itemId={item.itemId}
            >
              <NavIconDiv>
                <NavIcon
                  $active={isActive(item.link)}
                  className={item.icon}
                  alt={item.info}
                />
              </NavIconDiv>
              {item.text}
            </Tab>
          ))}
          <LastElements collapsed={collapsed}>
            {content.slice(-2).map(item => (
              <Tab
                key={item.itemId}
                active={isActive(item.link)}
                info={item.info}
                linkOptions={item.linkOptions}
                link={item.link}
                itemId={item.itemId}
              >
                <NavIconDiv>
                  <NavIcon
                    $active={isActive(item.link)}
                    className={item.icon}
                    alt={item.info}
                  />
                </NavIconDiv>
                {item.text}
              </Tab>
            ))}
          </LastElements>
        </Ul>
      </Nav>
    </>
  );
};

export default NavigationBar;

const Nav = styled.nav`
  position: ${({ locked }) => (locked ? 'static' : 'absolute')};
  z-index: 999;
  height: 100%;
  border-right: 1px solid ${themeGet('colors.black.10')};

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const NavIconDiv = styled.div`
  min-width: 65px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const NavIcon = styled.i`
  color: ${({ $active }) =>
    $active ? themeGet('colors.white') : themeGet('colors.black.80')};
  font-size: 1.4em;

  &.fa-paper-plane-top {
    transform: rotate(315deg);
  }
`;

const Ul = styled.ul`
  transition: width 0.3s ease-in-out;
  background-color: ${themeGet('colors.white')};
  display: flex;
  flex-direction: column;
  width: ${({ collapsed }) => (collapsed ? '65px' : '290px')};
  position: sticky;
  top: 0;
  height: calc(100vh - 70px);
`;

const Link = styled(Text)`
  overflow: hidden;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  color: ${({ active }) =>
    active ? themeGet('colors.white') : themeGet('colors.black.100')};
  &:focus-visible {
    border: 1px solid ${themeGet('colors.primary.100')};
  }
`;

const LastElements = styled.div`
  position: fixed;
  bottom: 0;
  border-top: 1px solid ${themeGet('colors.black.10')};
  width: ${({ collapsed }) => (collapsed ? '65px' : '290px')};
  transition: width 0.3s ease-in-out;
`;

const Li = styled.li`
  height: 44px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  background: ${({ active }) =>
    active ? themeGet('colors.black.100') : themeGet('colors.white')};

  &:hover {
    ${({ active }) =>
      !active &&
      css`
        background: ${themeGet('colors.black.5')};
      `};
  }
`;
